var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenTrkSel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.141602,
    width: 28,
    height: 20,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_4164)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9826 5.88228L17.0452 5.86875V3.15245C17.0452 2.74794 16.8874 2.38252 16.6301 2.11736C16.3747 1.85019 16.0228 1.68628 15.6332 1.68628H3.05332C2.62414 1.68628 2.23842 1.88778 1.97869 2.20408C1.61082 2.6527 1.64124 3.08678 1.64124 3.60709V14.8793C1.64124 15.6768 2.27462 16.3836 3.05332 16.3836H5.35948C5.5719 16.3836 5.74231 16.2061 5.74231 15.9861C5.74231 15.766 5.5719 15.5891 5.35948 15.5891V15.5911H3.05091C2.69076 15.5911 2.40642 15.2427 2.40642 14.8793V3.59556C2.40642 3.24669 2.34124 2.94092 2.60001 2.67576C2.72043 2.55129 2.8834 2.48137 3.05332 2.48127H15.6332C15.8108 2.48127 15.973 2.55746 16.0899 2.67876C16.2062 2.80007 16.2801 2.96799 16.2801 3.15245V15.5911H13.2425C13.0306 15.5911 12.8597 15.7685 12.8597 15.9886C12.8597 16.2086 13.0306 16.3856 13.2425 16.3856H16.6624C16.8744 16.3856 17.0452 16.2086 17.0452 15.9886V15.537H18.5915C18.7663 11.4021 24.4851 10.8317 25.0668 15.537H26.323C26.6464 11.5054 24.7289 9.93844 21.8125 9.58405C21.603 8.63768 21.2028 7.75948 20.7509 6.89131C20.2136 5.85922 20.0881 5.90083 18.9826 5.88228ZM9.33986 3.87626C9.63821 3.87626 9.93028 3.91135 10.2103 3.97751C10.4985 4.04518 10.7751 4.14644 11.0353 4.27626C11.0633 4.2903 11.0754 4.32589 11.0619 4.35496C11.0575 4.36448 11.0513 4.372 11.0435 4.37752L10.7471 4.62514L10.469 4.86524C10.4531 4.87927 10.4319 4.88228 10.4135 4.87526C10.2446 4.8116 10.0679 4.76248 9.88635 4.7294C9.70966 4.69732 9.52669 4.68027 9.34035 4.68027C8.5042 4.68027 7.71006 5.02163 7.11915 5.63567C6.52729 6.2507 6.19852 7.07326 6.19852 7.94244C6.19852 9.26475 6.96757 10.4542 8.13875 10.9575C9.74539 11.6487 11.5866 10.8402 12.2442 9.19006C12.4017 8.79448 12.4826 8.37051 12.4822 7.94244C12.4822 7.73091 12.4629 7.52339 12.4238 7.31587C12.4209 7.29783 12.4257 7.27978 12.4358 7.26675L12.6869 6.93191L12.9456 6.59657C12.952 6.58851 12.9603 6.58236 12.9697 6.57876C12.9792 6.57515 12.9894 6.57422 12.9992 6.57606C13.0091 6.5779 13.0184 6.58244 13.026 6.58921C13.0336 6.59599 13.0394 6.60476 13.0427 6.61462C13.1851 7.04168 13.2565 7.49081 13.2565 7.94244C13.2565 8.49282 13.1508 9.01813 12.9596 9.49683C12.1399 11.553 9.8458 12.5615 7.8433 11.7003C6.38825 11.0753 5.42369 9.59658 5.42369 7.94244C5.42369 6.86123 5.83452 5.83166 6.57073 5.06724C7.30695 4.30283 8.29854 3.87626 9.33986 3.87626ZM9.25152 13.3896C7.82013 13.3896 6.65908 14.5951 6.65908 16.0813C6.65908 17.5675 7.82013 18.7731 9.25152 18.7731C10.6829 18.7731 11.8435 17.5675 11.8435 16.0813C11.8415 14.5951 10.6829 13.3896 9.25152 13.3896ZM9.25152 15.0467C8.70262 15.0467 8.25461 15.5089 8.25461 16.0813C8.25461 16.6517 8.7002 17.1164 9.25152 17.1164C9.80042 17.1164 10.2484 16.6537 10.2484 16.0813C10.246 15.5089 9.80042 15.0467 9.25152 15.0467ZM21.8212 12.9936C20.3903 12.9936 19.2293 14.1991 19.2293 15.6853C19.2293 17.1715 20.3903 18.3771 21.8212 18.3771C23.2526 18.3771 24.4137 17.1715 24.4137 15.6853C24.4137 14.1991 23.2526 12.9936 21.8212 12.9936ZM20.8248 15.6853C20.8248 16.2557 21.2699 16.7204 21.8212 16.7204C22.3725 16.7204 22.8181 16.2578 22.8181 15.6853C22.8181 15.1129 22.3725 14.6507 21.8212 14.6507C21.2714 14.6507 20.8248 15.1139 20.8248 15.6853ZM19.1684 7.03116L18.0006 7.0086V9.58856H20.4743C20.1692 8.66826 19.7178 7.82464 19.1684 7.03116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41273 6.07666H8.54297V8.06789L9.97475 9.55452L10.5891 8.91669L9.41273 7.6953V6.07666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36448 3.89185C7.20433 3.89185 5.4541 5.71035 5.4541 7.95202C5.4541 10.1937 7.20551 12.0122 9.36448 12.0122C11.5246 12.0122 13.2749 10.1937 13.2749 7.95202C13.2749 5.71035 11.5234 3.89185 9.36448 3.89185ZM9.36448 11.1116C7.68674 11.1116 6.32268 9.69526 6.32268 7.95325C6.32268 6.21124 7.68674 4.79493 9.36448 4.79493C11.0422 4.79493 12.4063 6.21124 12.4063 7.95325C12.4063 9.69526 11.041 11.1116 9.36448 11.1116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.00586,
    y1: 3.24072,
    x2: 14.675,
    y2: 3.24072,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.00586,
    y1: 4.59424,
    x2: 5.41968,
    y2: 4.59424,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.2617,
    y1: 4.59424,
    x2: 15.6755,
    y2: 4.59424,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.25,
    x2: 2.12414,
    y2: -0.25,
    transform: "matrix(1 1.81089e-06 -4.22045e-09 1 13.5508 10.9595)",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.25,
    x2: 2.12414,
    y2: -0.25,
    transform: "matrix(1 1.81089e-06 -4.22045e-09 1 3.00586 10.96)",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12.75,
    x2: 16,
    y2: 12.75,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.9375,
    y1: 5.84741,
    x2: 15.6754,
    y2: 5.84741,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.25,
    x2: 1.54484,
    y2: -0.25,
    transform: "matrix(1 1.81089e-06 -4.22045e-09 1 14.1309 9.75659)",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.25,
    x2: 1.54484,
    y2: -0.25,
    transform: "matrix(1 1.81089e-06 -4.22045e-09 1 3.00586 9.75659)",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.4678,
    y1: 7.02539,
    x2: 15.6756,
    y2: 7.02539,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.00586,
    y1: 7.05029,
    x2: 4.21373,
    y2: 7.05029,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.00586,
    y1: 8.30347,
    x2: 4.21373,
    y2: 8.30347,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.4688,
    y1: 8.30347,
    x2: 15.6766,
    y2: 8.30347,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.00586,
    y1: 5.84741,
    x2: 4.74379,
    y2: 5.84741,
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_4164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.7174,
    height: 17.0868,
    fill: "white",
    transform: "translate(1.64062 1.68628)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenTrkSel);
export default __webpack_public_path__ + "static/media/penTrkSel.21e8437be401cad9b9ec7e8b509563b0.svg";
export { ForwardRef as ReactComponent };